import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import { invert } from '../../utils/protoutil';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidSetPresentationPropertiesMutationData } from '../base/valid-mutation-data';

export class SetPresentationPropertiesMutation extends BaseMutation<
    PresentationDataModel,
    IValidSetPresentationPropertiesMutationData
> {
    public readonly type: MutationType = MutationType.SetPresentationProperties;

    public apply(presentation: PresentationDataModel) {
        const {
            defaultTextStyle,
            tableStyleList,
            embeddedFontList,
            showSpecialPlsOnTitleSld,
            firstSlideNum,
            slideGuideList,
            modifyVerifier,
        } = this.data;

        presentation.store.patchData(
            {
                defaultTextStyle,
                tblStyleList: tableStyleList,
                embeddedFontList,
                showSpecialPlsOnTitleSld,
                firstSlideNum,
                slideGuideList: slideGuideList?.guide,
                modifyVerifier,
            },
            { slideGuideList: true, defaultTextStyle: true },
        );
    }

    public invert(presentation: PresentationDataModel): [IValidSetPresentationPropertiesMutationData] {
        const {
            defaultTextStyle,
            tableStyleList,
            embeddedFontList,
            showSpecialPlsOnTitleSld,
            firstSlideNum,
            slideGuideList,
            modifyVerifier,
        } = this.data;
        const presentationData = presentation.store.data;

        return [
            {
                type: MutationType.SetPresentationProperties,
                ...invert(
                    {
                        defaultTextStyle: presentationData.defaultTextStyle,
                        tableStyleList: presentationData.tblStyleList,
                        embeddedFontList: presentationData.embeddedFontList,
                        showSpecialPlsOnTitleSld: presentationData.showSpecialPlsOnTitleSld,
                        firstSlideNum: presentationData.firstSlideNum,
                        slideGuideList: presentationData.slideGuideList && {
                            guide: presentationData.slideGuideList,
                        },
                        modifyVerifier: presentationData.modifyVerifier,
                    },
                    {
                        defaultTextStyle,
                        tableStyleList,
                        embeddedFontList,
                        showSpecialPlsOnTitleSld,
                        firstSlideNum,
                        slideGuideList,
                        modifyVerifier,
                    },
                    {
                        slideGuideList: true,
                        defaultTextStyle: true,
                    },
                ),
            },
        ];
    }

    public check(): MaybeError {
        return;
    }
}
